import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
import mean from 'lodash/mean';
import { mapState } from 'vuex';
import formMixin from '../formMixin';
export default {
  name: 'NiotaClassicApplicationsMap',
  mixins: [formMixin],
  props: {
    applicationObj: {
      type: Object,
      required: true
    },
    interactiveMap: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      csvFormDialog: false,
      isLoadingDevices: true,
      devicesPlain: [],
      devicesMarkers: [],
      fullScreenMap: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])
  },
  watch: {
    applicationObj: debounce(function () {
      // Items have already been requested
      if (this.isFetchingDevices) {
        return;
      }
      this.getApplicationDevicesPlain();
    }, 500)
  },
  mounted() {
    this.getApplicationDevicesPlain();
  },
  methods: {
    getApplicationDevicesPlain() {
      // console.log('Fetching devices.....');
      if (this.isFetchingDevices) {
        return;
      }
      this.isFetchingDevices = true;
      this.isLoadingDevices = true;
      return NiotaClassicApiService.getApplicationDevicesPlain(this.$route.params.applicationId).then(res => {
        this.devicesPlain = res.data.devices;
        this.addDeviceMarker();
      }).catch(error => {
        console.error('Error:', error);
      }).finally(() => {
        this.isFetchingDevices = false;
        this.isLoadingDevices = false;
      });
    },
    addDeviceMarker(maxMarker = 100) {
      let devices = this.devicesPlain;
      devices.length > maxMarker ? devices = devices.slice(0, maxMarker) : devices;
      devices.forEach(device => {
        let mediumValues = {
          rssi: 0,
          lsnr: 0
        };
        let popUpMessage = `<b>Device:</b> ${device.title}`;
        let lat = device.lat;
        let lng = device.lon;
        if (!isNaN(lat) && !isNaN(lng)) {
          if (device.packets.length) {
            // Check if there is a server_data and gwrx record
            let firstPacket = device.packets[0];
            let isActilityDevice = firstPacket.source && firstPacket.source.toLowerCase() === 'actility';
            if (get(firstPacket, 'source_data.server_data') || isActilityDevice) {
              // for actility devices
              if (isActilityDevice) {
                mediumValues = this.calcualteActilityDevicesRx(firstPacket.signal);
              } else {
                mediumValues = this.calcualteMediumReceptionValues(firstPacket.source_data.server_data.gwrx);
              }
            } else {
              // No Server-Data and GWRX, set to fix value
              mediumValues.rssi = -60;
            }
            popUpMessage = `${popUpMessage}<br /><b>RSSI:</b> ${mediumValues.rssi}` + `<br /><b>SNR:</b> ${mediumValues.lsnr}`;
          }
          let marker = {
            message: popUpMessage,
            // coordinates: {
            //   lat: Number(lat),
            //   lon: Number(lng),
            // },
            coordinates: [Number(lng), Number(lat)]
          };
          this.devicesMarkers.push(marker);
        }
      });
      if (!this.devicesMarkers.length) {
        this.$emit('hide-map', true);
      }
    },
    calcualteActilityDevicesRx: signal => {
      return {
        rssi: signal.rssi,
        lsnr: signal.snr
      };
    },
    calcualteMediumReceptionValues: gwrx => {
      let rssis = [];
      let lsnrs = [];
      gwrx.forEach(gw => {
        rssis.push(gw.rssi);
        lsnrs.push(gw.lsnr);
      });
      return {
        rssi: mean(rssis),
        lsnr: mean(lsnrs)
      };
    }
  }
};